<template>
    <div class="index_table">
        <table class="tableClass" border="0" cellspacing="" cellpadding="">
            <tr :class="[index%2 == 0? 'white':'grey']" v-for="(item,index) in qiyeList" :key="index">
                <td>{{item.companyName}}</td>
                <td class="blue"><a :href="item.webUrl" target="_blank">{{item.webUrl}}</a></td>
            </tr>
            
        </table>
    </div>
</template>
<script>
export default {
    name:'indexTable',
    data(){
        return{
            qiyeList:[]
        }
    },
    methods:{
        init(){
            var _this = this;
            this.getRequest("api/clue/ipReport",{n:1}).then(res=>{
                if (res.data.status == 200) {
                    var cc = [];
                    var item = res.data.obj.list;
                    for (let index = 0; index < item.length; index++) {
                        if(index < 5){
                            cc.push(item[index]);
                        }
                    }
                    _this.qiyeList = cc;
                }
            })
        }
    },
    mounted(){
        this.init();
    }
}
</script>
<style lang="scss" scoped>

.index_table{
    height: auto;
    margin: 0 auto;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >table.tableClass{
        width: 100%;
        height: auto;
        cursor: default;
        >tr.white{
            width: 100%;
            height: 100px;
            background-color: #fff;
            font-size: 24px;
            color: #333333;
            text-align: center;
            td.blue{
                color: #4192FE;
                a{
                    color: #4192FE;
                    text-decoration: none;
                }
            }
        }
        >tr.grey{
            width: 100%;
            height: 100px;
            background-color: #F9F9F9;
            font-size: 24px;
            color: #333333;
            text-align: center;
            td.blue{
                color: #4192FE;
                a{
                    color: #4192FE;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modular/index_table.vue